<template>
  <v-content>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <div class="home">
          <img alt="Logo" width="250px" src="/img/logo.svg" />
          <br/>
          <HelloWorld msg="Trabajo de fin de grado" />
          <br/>
          <br/>
          <br/>
        </div>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloPage.vue";

export default {
  name: "Home",
  components: {
    HelloWorld
  }
};
</script>

<style>
  .home {
    text-align: center;
  }
</style>
